/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateOrUpdateUserTokenInput = {
    crentPassword?: string | null | undefined;
    defaultLanguage?: string | null | undefined;
    email?: string | null | undefined;
    firstname?: string | null | undefined;
    lastname?: string | null | undefined;
    token?: string | null | undefined;
    username: string;
};
export type CreateOrUpdateUserTokenMutationVariables = {
    input: CreateOrUpdateUserTokenInput;
};
export type CreateOrUpdateUserTokenMutationResponse = {
    readonly createUserWithToken: boolean | null;
};
export type CreateOrUpdateUserTokenMutation = {
    readonly response: CreateOrUpdateUserTokenMutationResponse;
    readonly variables: CreateOrUpdateUserTokenMutationVariables;
};



/*
mutation CreateOrUpdateUserTokenMutation(
  $input: CreateOrUpdateUserTokenInput!
) {
  createUserWithToken(input: $input)
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "createUserWithToken",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOrUpdateUserTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateOrUpdateUserTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9ad6fde03bc23c1febc0cc878e758fca",
    "id": null,
    "metadata": {},
    "name": "CreateOrUpdateUserTokenMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOrUpdateUserTokenMutation(\n  $input: CreateOrUpdateUserTokenInput!\n) {\n  createUserWithToken(input: $input)\n}\n"
  }
};
})();
(node as any).hash = '514136913ad3392e14cdc9b2fb43c4b0';
export default node;
